import React, { useState } from "react";
import { Settings, ShieldCheck } from "lucide-react";
import Button from "../../../components/core/Element/Button/Button";
import { getStoreInfo } from "../../../utils/_hooks";

const Advanced = () => {
  const store = getStoreInfo();
  const [seo, setSeo] = useState({
    metaTitle: store?.name ? `${store.name} - Online Menu & Ordering` : "",
    metaDescription: `Order fresh food online directly from ${store?.name || "our restaurant"}. Fast delivery & easy pick-up.`,
    customCss: "",
  });

  return (
    <div className="d-flex flex-column gap-4 bg-light mt-3 p-3 rounded">
      <div>
        <h3>Advanced Shop Settings</h3>
        <p className="text-muted">
          Configure search engine optimization (SEO) and custom metadata for your shop domain.
        </p>
      </div>

      <div className="card p-3 border-0 shadow-sm">
        <h5 className="mb-3 d-flex align-items-center gap-2">
          <Settings size={18} /> SEO & Metadata
        </h5>

        <div className="mb-3">
          <label className="form-label fw-semibold">Page Title (Meta Title)</label>
          <input
            type="text"
            className="form-control"
            value={seo.metaTitle}
            onChange={(e) => setSeo({ ...seo, metaTitle: e.target.value })}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Meta Description</label>
          <textarea
            className="form-control"
            rows="3"
            value={seo.metaDescription}
            onChange={(e) => setSeo({ ...seo, metaDescription: e.target.value })}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Subdomain Status</label>
          <div className="d-flex align-items-center gap-2 text-success fw-semibold bg-success bg-opacity-10 p-2 rounded">
            <ShieldCheck size={18} />
            <span>https://{store?.domainName || "yourshop"}.aduppankarai.com (SSL Active)</span>
          </div>
        </div>

        <div className="mt-4">
          <Button label="Save Advanced Settings" onClick={() => alert("Advanced settings saved!")} />
        </div>
      </div>
    </div>
  );
};

export default Advanced;
